<div
  class="input-dropdown-container"
  (focusout)="checkFocus($event)"
  [ngStyle]="{ position: variant === 'standard' ? 'relative' : {} }"
>
  @if(variant === 'standard'){
  <div class="dropdown-top">
    <sl-input
      id="{{ 'sl-dropdown-input-' + name }}"
      [control]="control"
      [errorMessages]="errorMessages"
      [placeholder]="placeholder"
      [label]="label"
      [required]="true"
      [icon]="displaySuggestions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
      [isReadOnly]="true"
      [isClickable]="true"
      [disabled]="disabled"
      (keydown)="onKeyDownButton($event)"
      (click)="handleDisplaySuggestions(disabled)"
    ></sl-input>
  </div>
  }@else if(variant === 'header'){ @if(label){
  <sl-typography
    [text]="label"
    variant="label"
    color="var(--color-neutral-90)"
  ></sl-typography>
  }
  <button
    id="{{ 'sl-dropdown-outer-button-' + name }}"
    [disabled]="disabled"
    tabindex="0"
    #outerButton
    (click)="this.handleDisplaySuggestions(disabled)"
    (keydown)="onKeyDownButton($event)"
    [ngClass]="{
      'sl-dropdown-outer-button': !lightTheme,
      'sl-dropdown-outer-button-light': lightTheme,
      'sl-dropdown-outer-button-opened': displaySuggestions && !lightTheme
    }"
    [attr.aria-label]="'selector selected element' + selectedSuggestion?.key"
  >
    @if(selectedSuggestion){
    <div class="outer-button-text">
      <sl-typography
        [text]="selectedSuggestion.key"
        [variant]="getTypographyVariant()"
        [color]="getTypographyColor()"
      ></sl-typography>
    </div>
    }
    <span
      class="material-symbols-outlined"
      [ngClass]="{
        'icon-light': lightTheme,
        'icon-dark': !lightTheme
      }"
      >{{ displaySuggestions ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </span>
  </button>
  } @if(this.displaySuggestions){
  <div
    [id]="'sl-dropdown-suggestions-container-' + name"
    class="sl-dropdown-suggestions-container"
    [ngClass]="
      variant === 'header' ? 'sl-dropdown-suggestions-container--header' : ''
    "
    [ngStyle]="variant === 'standard' ? undefined : { 'margin-top': '12px' }"
    container="body"
    #suggestionsContainer
  >
    @for(suggestion of suggestions; track suggestion; let i = $index){
    <sl-menu-item
      [item]="suggestion"
      [isDisabled]="optionsDisabled.includes(suggestion.value)"
      (clickEvent)="onClickSuggestion($event)"
      (keyDownEvent)="onKeyDownSuggestion($event)"
      [isSelected]="selectedSuggestion?.key === suggestion.key"
      [iconSelected]="variant === 'standard' ? 'check' : undefined"
    ></sl-menu-item>
    }
  </div>
  }
</div>
